export enum VehicleTypes {
  Car = 'CAR',
  Wagon = 'WAGON',
  MiniBus = 'MINIBUS',
  PrivateBus = 'PRIVATE_BUS',
  Truck = 'TRUCK',
  Trailer = 'TRAILER',
}

export const soapVehicleTypeTranslate: {
  [key: string]: string;
} = {
  [VehicleTypes.Car]: 'Auto/Jeep/SW',
  [VehicleTypes.Wagon]: 'Camioneta Furgon',
  [VehicleTypes.MiniBus]: 'Minibus',
  [VehicleTypes.PrivateBus]: 'Bus particular',
  [VehicleTypes.Truck]: 'Camión y tractor',
  [VehicleTypes.Trailer]: 'Remolque',
};

const vehicleTypeMapper: {
  [key: string]: string;
} = {
  Automovil: soapVehicleTypeTranslate[VehicleTypes.Car],
  Bus: soapVehicleTypeTranslate[VehicleTypes.PrivateBus],
  Cabriolet: soapVehicleTypeTranslate[VehicleTypes.Car],
  Camion: soapVehicleTypeTranslate[VehicleTypes.Truck],
  Camioneta: soapVehicleTypeTranslate[VehicleTypes.Wagon],
  'Casa Rodante': soapVehicleTypeTranslate[VehicleTypes.Trailer],
  'Chasis Cabina': soapVehicleTypeTranslate[VehicleTypes.Truck],
  Convertible: soapVehicleTypeTranslate[VehicleTypes.Car],
  Coupe: soapVehicleTypeTranslate[VehicleTypes.Car],
  Electrico: soapVehicleTypeTranslate[VehicleTypes.Car],
  Furgon: soapVehicleTypeTranslate[VehicleTypes.Wagon],
  'Furgon Cerrado': soapVehicleTypeTranslate[VehicleTypes.Wagon],
  'Hatch Back': soapVehicleTypeTranslate[VehicleTypes.Car],
  Hatchback: soapVehicleTypeTranslate[VehicleTypes.Car],
  Jeep: soapVehicleTypeTranslate[VehicleTypes.Car],
  Limusina: soapVehicleTypeTranslate[VehicleTypes.MiniBus],
  Microvan: soapVehicleTypeTranslate[VehicleTypes.Wagon],
  Minibus: soapVehicleTypeTranslate[VehicleTypes.MiniBus],
  Minivan: soapVehicleTypeTranslate[VehicleTypes.Car],
  Roadster: soapVehicleTypeTranslate[VehicleTypes.Car],
  Sedan: soapVehicleTypeTranslate[VehicleTypes.Car],
  Sportback: soapVehicleTypeTranslate[VehicleTypes.Car],
  'Station Wagon': soapVehicleTypeTranslate[VehicleTypes.Car],
  SUV: soapVehicleTypeTranslate[VehicleTypes.Car],
  'Transporte de Pasajeros': soapVehicleTypeTranslate[VehicleTypes.PrivateBus],
};

export default vehicleTypeMapper;
